﻿import { IMicrositeRecipientImagePosition } from './microsite-recipient-image-position';

export interface IMicrositeRecipientImageAttributes {
    zoom: number;
    rotate: number;
    position: IMicrositeRecipientImagePosition;
}
